import { PaperWrapped, HeaderWrapped } from '../lab-result/component/styled';
import { convertToFormData, dummyRequest } from '../lab-result/utils';
import batchVaccinationRecordUpdateDispatcher from './action';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import customToast from '@/new-components/CustomNotification';
import { InboxOutlined } from '@ant-design/icons';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Upload } from 'antd';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';

const BatchVaccinationRecordUpdate = () => {
  const [files, setFiles] = useState({});

  const handleUploadFiles = () => {
    if (isEmpty(files)) return customToast('error', 'File must not be empty');

    batchVaccinationRecordUpdateDispatcher.uploadBatchVaccinationRecord(
      convertToFormData(files.originFileObj, 'file')
    );
  };

  const handleChangeFiles = (e) => {
    setFiles(e.file);
  };

  const handleClearFiles = () => setFiles({});

  return (
    <PaperWrapped>
      <HeaderWrapped className="no-tabs-header">
        <Typography style={{ fontSize: 18, fontWeight: 600 }}>
          Batch Vaccination Record Update
        </Typography>

        <div className="personal-btn">
          <ButtonEnhance
            background="#E9E9E9"
            color="black"
            backgroundHover="#ccc"
            onClick={handleClearFiles}
          >
            Clear
          </ButtonEnhance>
          <ButtonEnhance onClick={handleUploadFiles}>Upload</ButtonEnhance>
        </div>
      </HeaderWrapped>
      <Box display="flex" alignItems="center" flexDirection="column">
        <Upload.Dragger
          customRequest={dummyRequest}
          onChange={handleChangeFiles}
          showUploadList={false}
          accept={'.xlsx'}
          file={files}
        >
          <div className="upload-btn">
            <div className="group">
              <InboxOutlined />
              <div className="text">
                {isEmpty(files)
                  ? 'Click or drag file to this area to upload'
                  : `${files.name}`}
              </div>
            </div>
          </div>
        </Upload.Dragger>
      </Box>
    </PaperWrapped>
  );
};

export default BatchVaccinationRecordUpdate;
